window.addEventListener('onCoursesRendered',() => {
    const publicCourses = new CreateCoursesBlocks();
    publicCourses.initInput();

    var buttonsDivWrapper = document.createElement('div');
    buttonsDivWrapper.className = 'additionalButtonsDivWrapper';

    var buttonsDivLink1  = document.createElement('a');
    buttonsDivLink1.href = '/account';
    buttonsDivLink1.innerText = 'My Account Details';


    buttonsDivWrapper.append(buttonsDivLink1);

    if(document.querySelector('.welcomeText p'))
    {
        document.querySelector('.welcomeText p').insertAdjacentElement('afterend',buttonsDivWrapper);
    }
});

window.addEventListener('onEmptyStateRendered',() => {
    if(document.querySelector('p.haventp'))
    {
        document.querySelector('p.haventp').remove();
        const coursesSearchBlock = document.querySelector('#coursesSearchBlock');
        if (coursesSearchBlock) {
            coursesSearchBlock.remove();
        }
    }

    const publicCourses = new CreateCoursesBlocks();
    publicCourses.initInput();

    var buttonsDivWrapper = document.createElement('div');
    buttonsDivWrapper.className = 'additionalButtonsDivWrapper';

    var buttonsDivLink1  = document.createElement('a');
    buttonsDivLink1.href = '/account';
    buttonsDivLink1.innerText = 'My Account Details';


    buttonsDivWrapper.append(buttonsDivLink1);

    const welcomeTextH4 = document.querySelector('.welcomeText h4');
    if (welcomeTextH4) {
        welcomeTextH4.insertAdjacentElement('afterend', buttonsDivWrapper);
    }
});


class CreateCoursesBlocks {
    coursesHtmlCollect = {};
    masterTitleText = 'Want to take your revision to the next level?';
    masterDescText = 'All of free revision courses are listed below';
    handlesArray = [];

    mainWrapper = document.createElement('div');

    constructor(inputSelector, maxCountCourses) {
        this.countCourses = maxCountCourses ? maxCountCourses : 8;
    }

    initInput() {
        if(!window.coursesListPublicData) {
            console.error('Public courses data is empty.');
            return;
        }

        this.buildMainBlock();
        this.addCoursesLink();
        this.addNewsletterSection();
        this.reorganizewelcomeBlock();

        try {
            const data = window.coursesListPublicData;

            this.buildHtml(data);

        } catch (e) {
            console.error('Failed to parse the JSON:', e);
        }
    }

    buildHtml(data) {

        let $i = 1;

        let appendBlock = '<div class="appendWrapper row">';

        for (const [key, course] of Object.entries(data)) {
            if($i > this.countCourses) break;

            if(parseInt(course.hidden)) { return; }

            if(typeof course.short_description !== "undefined"){
                course.description = course.short_description;
            }

            let category = '';

            if(typeof course.category !== "undefined") {
                if(course.category != '') {
                    category = course.category;
                    if(this.handlesArray.indexOf(course.category.trim()) < 0) {
                        this.handlesArray.push(course.category.trim());
                    }
                }
            }

            appendBlock += '<div class="col-md-4 col-lg-4 col-sm-6 col-xs-12 courseBlock-add" data-attr-category="'+category+'"  data-attr-order="'+course.order+'" >';

            const coursesActionsBlock = this.getOpenCoursesActionsBlock(course);
            appendBlock += coursesActionsBlock;

            appendBlock += `<a href="https://${Shopify.shop}/apps/my/course/${course.handle}" target="_blank">`;

            let redirectLink = `https://${Shopify.shop}/apps/my/course/${course.handle}`;

            if(typeof course.image !== 'undefined') {
                if(course.image !== null) {
                    appendBlock += '<img src="'+course.image+'" loading="lazy" />';
                } else {
                    appendBlock += '<img src="https://cdn.shopify.com/s/files/1/0504/5829/6488/products/no_image.png" loading="lazy" />';
                }
            } else {
                appendBlock += '<img src="https://cdn.shopify.com/s/files/1/0504/5829/6488/products/no_image.png" loading="lazy" />';
            }

            let viewUrl = 'window.location.href=\''+redirectLink+'\'';

            let authenticationRequired = "false";
            // if typeform pre-form settiong enabled, and student does not has a cookie we need to redirect customer on typeform page
            if((typeof course.settings != "undefined") && (course.settings !== null))
            {
                const currentSettings = JSON.parse(course.settings);

                if(typeof currentSettings.tf_status != "undefined") {
                    if(parseInt(currentSettings.tf_status)) {
                        if(!window.getCoursesCookie('courses_open_cookie_'+course.public_course_id)) {
                            let tfUrlArray = currentSettings.tf_url.split('/');
                            let redirectLink = '<%LINKURL%>courseform/'+tfUrlArray[tfUrlArray.length-1]+'/'+course.handle;
                            let viewUrl = 'window.location.href=\''+redirectLink+'\'';
                        }
                    }
                }

                if(typeof currentSettings.authenticationAccess != "undefined") {
                    if(currentSettings.authenticationAccess == true) {
                        authenticationRequired = "true";
                    }
                }
            }

            appendBlock += '</a><div class="infoWrapper"><div class="absoluteInfo"><h4 onclick="'+viewUrl+'">'+course.title+'</h4>';

            if(course.description !== null && typeof course.description !== 'undefined' && course.description.length) {
                appendBlock += '<p class="courseDescription">'+course.description
                    .replace(/<\/?[^>]+(>|$)/g, "")
                    .replace(/\r?\n/g, "")
                    .replace(/^(.{150}[^\s]*).*/, "$1")+'</p>';
            } else {
                appendBlock += '<p class="courseDescription"></p>';
            }

            let completion_time = '';
            if(course.completion_hours || course.completion_minutes) {
                if(course.completion_hours == 1) {
                    completion_time = '<p class="courseComplTime"><i class="preTimeDot">•</i> '+course.completion_hours+' '+window.frontLibrary[29]+' '+course.completion_minutes+' '+window.frontLibrary[52]+'</p>';
                } else {
                    completion_time = '<p class="courseComplTime"><i class="preTimeDot">•</i> '+course.completion_hours+' '+window.frontLibrary[30]+' '+course.completion_minutes+' '+window.frontLibrary[52]+'</p>';
                }
            } else {
                completion_time = '';
            }

            let dwnldBtnText = '';
            if(typeof window.frontLibrary[99] != 'undefined' && window.frontLibrary[99] != null) {
                dwnldBtnText = ' '+window.frontLibrary[99];
            } else {
                dwnldBtnText = '';
            }

            let courseBtnEnable = 'style="display:none;"';
            if(typeof course.download_link != 'undefined') {
                if(course.download_link != '') {
                    let courseBtnEnable = 'download';
                }
            } else {
                course.download_link = '';
            }

            let appendBtn = '';
            if(course.buttontext != '') {
                appendBtn = '<button data-attr-shop="@{{shop.permanent_domain}}"  class="c_dfile_button" data-prod-id="'+course.id+'" '+courseBtnEnable+' onclick="window.openDownload(this,\''+course.download_link+'\')"><span>'+course.buttontext+'</span></button>';
            } else {
                appendBtn = '<button data-attr-shop="@{{shop.permanent_domain}}"  class="c_dfile_button" data-prod-id="'+course.id+'" '+courseBtnEnable+' onclick="window.openDownload(this,\''+course.download_link+'\')"><span><svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.6764 5.29412H9.14701V0H3.8529V5.29412H0.323486L6.49996 11.4706L12.6764 5.29412ZM0.323486 13.2353V15H12.6764V13.2353H0.323486Z" fill="white"/></svg>'+dwnldBtnText+'</span></button>';
            }

            appendBlock += completion_time+'</div><button data-authentication-required="'+authenticationRequired+'" onclick="'+viewUrl+'">'+window.frontLibrary[7]+'</button>'+appendBtn;
            appendBlock += '</div></div>';

            $i++;
        }

        appendBlock += '</div>';

        document.getElementById('courses-wrap').innerHTML = appendBlock;

    }

    getOpenCoursesActionsBlock(courseData) {
        if(typeof courseData.handle != "undefined") {
            var shopDomain = Shopify.shop;
        }

        if(typeof Shopify.cdnHost != "undefined") {
            shopDomain = Shopify.cdnHost.replace('/cdn','');
        }

        if(location.href.includes('my2')) {
            var courseLink = 'https://'+shopDomain+'/apps/my2/course/'+courseData.handle;
        } else {
            var courseLink = 'https://'+shopDomain+'/apps/my/course/'+courseData.handle;
        }

        if(typeof courseData.download_link == 'undefined'){
            courseData.download_link = '';
        }

        let svgIcon = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M503.7 226.2l-176 151.1c-15.38 13.3-39.69 2.545-39.69-18.16V272.1C132.9 274.3 66.06 312.8 111.4 457.8c5.031 16.09-14.41 28.56-28.06 18.62C39.59 444.6 0 383.8 0 322.3c0-152.2 127.4-184.4 288-186.3V56.02c0-20.67 24.28-31.46 39.69-18.16l176 151.1C514.8 199.4 514.8 216.6 503.7 226.2z"/></svg>';
        let resultHtml = '<div class="coursesActionsMark" onclick="window.courseActionHandle(this)">';
        resultHtml += '<svg xmlns="http://www.w3.org/2000/svg" width="4" height="18" viewBox="0 0 4 18" fill="none">';
        resultHtml += '<path d="M3.60001 1.8C3.60001 0.805911 2.79411 0 1.8 0C0.805886 0 0 0.805911 0 1.8C0 2.79411 0.805886 3.6 1.8 3.6C2.79411 3.6 3.60001 2.79411 3.60001 1.8ZM3.60001 9C3.60001 8.00591 2.79411 7.2 1.8 7.2C0.805886 7.2 0 8.00591 0 9C0 9.99411 0.805886 10.8 1.8 10.8C2.79411 10.8 3.60001 9.99411 3.60001 9ZM3.60001 16.2C3.60001 15.2059 2.79411 14.4 1.8 14.4C0.805886 14.4 0 15.2059 0 16.2C0 17.1941 0.805886 18 1.8 18C2.79411 18 3.60001 17.1941 3.60001 16.2Z" fill="white"></path>';
        resultHtml += '</svg>';
        resultHtml += '<ul class="courseActionMenu">';

        if(courseData.download_link.length) {
            resultHtml += '<li><span><a href="javascript:void(0)" data-prod-id="'+courseData.id+'" onclick="window.openDownload(this,\''+courseData.download_link+'\')"><svg width="13" height="15" viewBox="0 0 13 15" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.6764 5.29412H9.14701V0H3.8529V5.29412H0.323486L6.49996 11.4706L12.6764 5.29412ZM0.323486 13.2353V15H12.6764V13.2353H0.323486Z" fill="white"></path></svg> '+window.frontLibrary[46].trim()+'</a></span></li>';
        }

        resultHtml += '<li><span onclick="window.shareCourseLinkPopUp(this)" data-attr-link="'+courseLink+'">'+svgIcon+window.frontLibrary[103]+'</span></li>';

        resultHtml += '</ul>';
        resultHtml += '</div>';

        return resultHtml;
    }

    buildMainBlock() {

        this.mainWrapper.classList.add('public_course_wrapper', 'additional-section');

        const title = document.createElement('h2');
        const desc = document.createElement('p');

        desc.classList.add('m-page-header__description');
        desc.textContent = this.masterDescText;

        title.textContent = this.masterTitleText;

        this.mainWrapper.appendChild(title);
        this.mainWrapper.appendChild(desc);

        const wrapDiv = document.createElement('div');
        wrapDiv.id = 'courses-wrap';

        this.mainWrapper.appendChild(wrapDiv);

        document.getElementById('apCB').appendChild(this.mainWrapper);
    }

    addCoursesLink() {
        const linkWrapper = document.createElement('div');
        linkWrapper.classList.add('link-wrap');

        const link = document.createElement('a');
        link.id = 'public-courses-link';
        link.setAttribute('href', `/apps/my/courses/public`);
        link.textContent = 'Browse all free resources';

        linkWrapper.appendChild(link);
        document.querySelector('.public_course_wrapper.additional-section').appendChild(linkWrapper);
    }

    async loadCSS(href) {
        return new Promise((resolve, reject) => {
            // Check if CSS is already loaded
            const existingLink = document.querySelector(`link[href*="${href}"]`);
            if (existingLink) {
                resolve();
                return;
            }

            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = href;
            link.onload = () => resolve();
            link.onerror = () => reject(new Error(`Failed to load CSS: ${href}`));
            document.head.appendChild(link);
        });
    }

    async addNewsletterSection() {
        try {
            // First, load the required CSS files
            // Use relative paths for Shopify assets
            await Promise.all([
                this.loadCSS('/assets/newsletter.css'),
                this.loadCSS('/assets/component-newsletter.css')
            ]);

            // Fetch the newsletter section from the account page (which already has it)
            const response = await fetch('/account', {
                method: 'GET',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest'
                },
                credentials: 'same-origin'
            });

            if (response.ok) {
                const html = await response.text();
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');
                
                // Find the newsletter section in the response
                const newsletterSection = doc.querySelector('#m-newsletter-account');
                
                if (newsletterSection) {
                    // Get the apCB container and append newsletter as last element
                    const apCBContainer = document.getElementById('apCB');
                    if (apCBContainer) {
                        // Clone the newsletter section to avoid any issues
                        const newsletterClone = newsletterSection.cloneNode(true);
                        
                        // Remove the script tag from clone (it won't execute anyway)
                        const scriptTag = newsletterClone.querySelector('script');
                        if (scriptTag) {
                            scriptTag.remove();
                        }
                        
                        // Append the clone to the DOM
                        apCBContainer.appendChild(newsletterClone);
                        
                        // Re-initialize the newsletter form JavaScript
                        // Use a small delay to ensure DOM is ready
                        setTimeout(() => {
                            this.initializeNewsletterForm('account');
                        }, 100);
                    }
                }
            }
        } catch (error) {
            console.error('Error loading newsletter section:', error);
        }
    }

    initializeNewsletterForm(customId) {
        const formId = 'ContactSubscribe-' + customId;
        const emailInput = document.getElementById(formId + '-email');
        const submitButton = document.getElementById(formId + '-submit');
        const agreeCheckbox = document.getElementById(formId + '-agree');
        const showAgreement = agreeCheckbox !== null;

        if (!emailInput || !submitButton) {
            console.warn('Newsletter form elements not found for formId:', formId);
            return;
        }

        function validateEmail(email) {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return emailRegex.test(email);
        }

        function updateButtonState() {
            const emailValue = emailInput.value.trim();
            const isEmailValid = validateEmail(emailValue);
            const isAgreementChecked = !showAgreement || (agreeCheckbox && agreeCheckbox.checked);

            submitButton.disabled = !(isEmailValid && isAgreementChecked);
        }

        // Attach event listeners
        emailInput.addEventListener('input', updateButtonState);
        emailInput.addEventListener('blur', updateButtonState);

        if (agreeCheckbox) {
            agreeCheckbox.addEventListener('change', updateButtonState);
        }

        // Initial state check (in case email is pre-filled)
        updateButtonState();
    }

    reorganizewelcomeBlock() {
        const welcomeText = document.querySelector('.welcomeText');
        const wrapper = document.querySelector('.courseListWrapper');
        if (welcomeText && wrapper) {
            wrapper.before(welcomeText);
        }
    }
}


